import { useObserver } from "mobx-react";
import React from "react";
import { Grid } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Select } from "@components/formx";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { Body } from "@components/typography/Body";
import { LanguageSkillLevel } from "@graphql";
import { FormControls } from "@components/forms";
import { SecondaryButton } from "@components";
import BasicSelect from "@components/Select";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "react-icons/lib/md/remove-circle";
import IconButton from "@material-ui/core/IconButton";

export function LanguageSkillsInfo() {
  const [newLanguage, setNewLanguage] = React.useState(null);
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  const classes = useStyles({});

  const allLevels = [
    { label: "", value: "" },
    { label: locale.LanguageLevelFluent, value: LanguageSkillLevel.Fluent },
    { label: locale.LanguageLevelGood, value: LanguageSkillLevel.Good },
    { label: locale.LanguageLevelOK, value: LanguageSkillLevel.OK }
  ];

  const _languages = [
    ...editorStore.mainLanguages.toLabelValue(locale.getLanguage),
    { disabled: true, label: locale.Other, value: "others" },
    ...editorStore.allLanguages
      .filter((x) => !editorStore.mainLanguages.includes(x))
      .sortBy((x) => x)
      .toLabelValue(locale.getLanguage)
  ].filter((x) => !editorStore.languageItems.any((y) => y.name === x.value));

  return useObserver(() => {
    return (
      <>
        {editorStore.languageItems.length === 0 && (
          <Grid item>
            <Body color="textSecondary" style={{ textAlign: "center" }}>
              ({locale.EmptyHere.toLocaleLowerCase()})
            </Body>
          </Grid>
        )}

        {editorStore.languageItems.map((item, i) => {
          const itemName = `languageSkills.items.${i}`;
          return (
            <div key={itemName} className={classes.row} data-test="LanguageSkillRow">
              <Select
                label={
                  locale.getLanguage(item.name) ||
                  editorStore.form.getError(`${itemName}.name`)
                }
                name={`${itemName}.level`}
                error={!!editorStore.form.getError(`${itemName}.name`)}
                options={allLevels}
                fullWidth
              />
              <IconButton
                data-test="deleteButton"
                onClick={() => editorStore.removeLanguage(i)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          );
        })}
        <FormControls
          fitted
          right={
            <>
              <BasicSelect
                fullWidth
                // name="__newLanguage"
                creatable
                label={locale.AddLanguageSkill}
                options={_languages}
                sortOptions={false}
                onChange={(value) => {
                  setNewLanguage(value);
                }}
                value={newLanguage}
              />

              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <SecondaryButton
                  onClick={() => {
                    newLanguage && editorStore.addLanguageSkill(newLanguage);
                    setNewLanguage(null);
                  }}
                  data-test="AddLanguage"
                  disabled={!newLanguage}
                  variant="text"
                >
                  {locale.Add}
                </SecondaryButton>
              </div>
            </>
          }
        />
      </>
    );
  });
}

const useStyles = makeStyles((theme: ThemeType) => ({
  row: {
    display: "flex",
    marginTop: theme.spacing(2)
  },

  addRow: {
    flex: 1,
    marginTop: theme.spacing()
  },

  addRowSelect: {
    flexBasis: "50%"
  }
}));
